// extracted by mini-css-extract-plugin
module.exports = {"qa_wrapper":"hw6dL_3T","title":"HtrOkYIX","item_title":"nUIcLfFe","item_text":"vuDWCRqM"};